// Auto-generated by infrastructure/scripts/write-outputs.ts
// Do not edit manually - run 'npm run write-outputs' to regenerate

export const config = {
  apiUrl: 'https://3u7l2oieil.execute-api.ap-southeast-2.amazonaws.com/api/',
  apiId: '3u7l2oieil',
  region: 'ap-southeast-2',
  // Cognito — update these after deploying BrokerMigrationAuthStack
  userPoolId: 'ap-southeast-2_dw1y5vijK',
  userPoolClientId: '1l1jcr9qaqifkbueavses1apnr',
} as const;
